import { Injectable } from '@angular/core';
import { FormControl, FormGroup, AbstractControl, ValidatorFn } from '@angular/forms';


@Injectable()
export class ValidatorService {
  private static minRange = 0;
  private static maxRange = 0;

  static formErrors(field: string, form: FormGroup, fsa: boolean): string {
    let message = '';
    const formField = form.controls[field];
    if (formField.touched || formField.untouched && fsa) {
      if (formField.hasError('required')) {
        message += '<span><p class="text-danger">Campo requerido</p></span>';
      }

      if (formField.hasError('email')) {
        message += '<span><p class="text-danger">El correo no es válido</p></span>';
      }

      if (formField.hasError('invalidChar')) {
        message += '<span><p class="text-danger">Los carácteres especiales no están permitidos</p></span>';
      }

      if (formField.hasError('onlyNumbers')) {
        message += '<span><p class="text-danger">Sólo se permiten números</p></span>';
      }

      if (formField.hasError('invalidPassword')) {
        message += '<span><p class="text-danger">Formato de contraseña inválido</p></span>';
      }

      if (formField.hasError('matchPassword')) {
        message += '<span><p class="text-danger">Las contraseñas deben coincidir</p></span>';
      }

      if (formField.hasError('rangeChars')) {
        message += `<span><p class="text-danger">Se aceptan mínimo ${this.minRange} y máximo ${this.maxRange} caracteres</p></span>`;
      }

      if (formField.hasError('minlength')) {
        message += `<span><p class="text-danger">Se aceptan mínimo ${formField.errors.minlength.requiredLength} caracteres</p></span>`;
      }

      if (formField.hasError('maxlength')) {
        message += `<span><p class="text-danger">Se aceptan máximo ${formField.errors.maxlength.requiredLength} caracteres</p></span>`;
      }

      if (formField.hasError('invalidCurp')) {
        message += '<span><p class="text-danger">La CURP ingresada no es válida</p></span>';
      }
    }
    return message;
  }

  static getError(controlName: string, form: FormGroup): boolean {
    let error = '';
    let obj = {} as any;
    const control = form.get(controlName);
    if (control.touched && control.errors != null) {
      error = JSON.stringify(control.errors);
      obj = JSON.parse(error);
    }
    return obj;
  }

  static matchPassword(firstControlName, secondControlName) {
    return (aC: AbstractControl) => {
      const firstControlValue = aC.get(firstControlName).value;
      const secondControlValue = aC.get(secondControlName).value;
      if (firstControlValue !== secondControlValue) {
        aC.get(secondControlName).setErrors({ 'matchPassword': true });
        return { 'matchPassword': true };
      } else {
        return null;
      }
    };
  }

  static formatPasswordValidator(control: FormControl): { [key: string]: any } {
    if (control.value) {
      if (control.value.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!.%*#?&])[A-Za-z\d$@$!.%*#?&]{8,}$/)) {
        return null;
      } else {
        return { 'invalidPassword': true };
      }
    }
  }
}
